import React from "react";
import { Navigate, Outlet, useParams } from "react-router-dom";
import { canAccessScreenwriting } from "./access";

// Guards the Screenwriting editor route (/editor/:id).
// Admins always pass; normal users need valid access (planFeatures present).
// Without access, direct URLs bounce back to the script's info page.
const ScreenwritingRoute = () => {
  const { id } = useParams();
  const user = JSON.parse(localStorage.getItem("user") || "{}");

  return canAccessScreenwriting(user) ? (
    <Outlet />
  ) : (
    <Navigate to={id ? `/scripts/${id}` : "/home"} replace />
  );
};

export default ScreenwritingRoute;
